
import { getRequest, } from '@/request/request';
import moment from 'moment';
import {
  ref,
  watch,
  onUnmounted,
  onMounted,
  defineComponent,
} from 'vue';
import * as echarts from 'echarts';
import {
  fontColorRender, weatherFactorColorRender, windDirection, remFontSize,
} from '@/utils/index';

export default defineComponent({
  props: {
    popupData: {
      type: Object,
      default: () => ({}),
      requir: true,
    },
  },

  setup (props,{ emit, }) {
    const weatherPopupEle = ref<any | null>(null);
    const weatherPopupData = ref<any>();
    const weatherHistoryData = ref<any>();
    // 要素对应文字
    const factorKey = {
      AOD: 'AOD',
      PM25: '<span>PM<sub>2.5</sub></span>',
      PM10: '<span>PM<sub>10</sub></span>',
      SO2: '<span>SO<sub>2</sub></span>',
      NO2: '<span>NO<sub>2</sub></span>',
      CO: 'CO',
      O3: '<span>O<sub>3</sub></span>',
      AQI: 'AQI',
      RADAR: '雷达',
      TEM: '气温',
      PRS: '气压',
      RHU: '湿度',
      PRE: '降水',
    };
    // 当前选中气体类型
    const activeAqiType = ref('pm25');
    const flag = ref<boolean>(false);
    const chart = ref<any>({});

    const unit = () => {
      if (activeAqiType.value === 'aqi') {
        return '';
      }

      if (activeAqiType.value === 'co') {
        return 'mg/m³';
      }

      return 'μg/m³';
    };

    /**
     *  配置柱状图
     * @param {any} val 配置项
     * @return {void}
     */
    const setChart = (val: any) => {
      setTimeout(() => {
        if (val && Object.keys(chart.value).length) {
          chart.value.setOption(val);
        }
      }, 1000);
    };

    /**
     * 初始化图表
     * @returns {void}
     */
    const initCharts = () => {
      const container = document.getElementById('weather-chart-container') as HTMLElement;

      chart.value = echarts.init(container);

      setTimeout(() => {

        // setChart(option);
      });
    };

    // 让正负值的圆角颠倒
    const caclBorderRadius = (value: any) => {
      if (Number(value) >= 0) {
        return [10,
          10,
          0,
          0,];
      }

      return [0,
        0,
        10,
        10,];
    };

    /**
     *  重置图表
     * @param {any} val value
     * @return {void}
     */
    const reSize = (): any => {
      if (Object.keys(chart.value).length) {
        chart.value.resize();
      }
    };

    const changeRankingVisable = () => {
      emit('close');
    };

    const getWeatherPopData = (pop:any) => {
      const params = {
        startIssue: moment().add(-3,'days').format('YYYYMMDD00'),
        endIssue: moment().format('YYYYMMDDHH'),
        stationId: pop.stationId,
      };

      getRequest('/airMap/getWeatherInfoDetailsForAirByTimes',params).then((res:any) => {
        weatherHistoryData.value = res.data.data;
      });
    };

    watch(() => props.popupData, (cur,old) => {
      weatherPopupData.value = cur;
      getWeatherPopData(cur);
    },{
      immediate: true,
    });

    watch(() => weatherHistoryData.value, (cur) => {
      const name = props.popupData?.infoWinType.toLowerCase();
      const temp:any = [];

      Object.keys(cur).forEach((element:any) => {
        if (Number(element)) {
          const tempItem = cur[element];

          tempItem.issue = element;
          temp.push(tempItem);
        }
      });

      //  柱状图配置项
      const option = {
        grid: {
          // x: '',
          y: remFontSize(0.1),
          // 高度
          height: '59%',
        },
        xAxis: {
          data: temp.map((item:any) => {
            const hour = moment(item.issue, 'YYYYMMDDHH').format('HH');

            if (hour === '00') {
              return `${hour},${moment(item.issue, 'YYYYMMDDHH').format('MM月DD日')}`;
            }

            return hour;
          }),
          // 隐藏刻度线
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            // 显示全部
            interval: 0,
            textStyle: {
              color: '#888888',
              fontSize: remFontSize(0.14),
            },
            formatter: (value: any) => {
              if (value.length > 2) {
                return value.replace(',', '\n');
              }
              if (Number(value) % 6 === 0) {
                return value;
              }

              return null;
            },
            align: 'left',
          },
          axisPointer: {
            show: true,
            type: 'shadow',
            label: {
              show: false,
            },
          },
        },
        yAxis: {
          type: 'value',
          // 隐藏y轴
          axisLine: {
            show: false,
          },
          // 隐藏刻度线
          axisTick: {
            show: false,
          },

          //  网格线设置
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#B3B3B3',
              opacity: '0.4',
            },
          },
          axisLabel: {
            interval: 6,
            show: true,
            textStyle: {
              fontSize: remFontSize(0.14),
              color: '#888888',
            },
          },
        },

        visualMap: {
          show: false,
          outOfRange: {
            color: '#999',
          },
        },

        series: [
          {
            type: 'bar',
            data: temp.map((item:any) => ({
              value: item[name],
              itemStyle: {
                normal: {
                  borderRadius: caclBorderRadius(item[name]),
                  color: weatherFactorColorRender(item[name] === null ?
                    -9999 :
                    item[name], name),
                },
              },
            })),
          },
        ],
        tooltip: {
          show: true,
          // trigger: 'axis',
          formatter: (param: any) => {
            const tempName = `${param.name.split('').splice(0,2).join('')}时`;

            return `<div style=" ">${param.marker}<span style="font-weight:bold;">${
              tempName
            }</span> ${param.value}${unit()}</div>`;
          },
          textStyle: {
            align: 'left',
            fontSize: '16',
          },
        },
      };

      setChart(option);
    },{
      deep: true,
    });

    onMounted(() => {
      flag.value = true;
      initCharts();
      window.addEventListener('resize', reSize());
    });

    /**
     * 销毁图表
     */
    onUnmounted(() => {
      echarts.dispose(chart);
      chart.value = {};
      flag.value = false;
    });

    return {
      moment,
      weatherPopupEle,
      weatherPopupData,
      weatherHistoryData,
      factorKey,
      activeAqiType,
      flag,
      chart,

      unit,
      setChart,
      initCharts,
      caclBorderRadius,
      reSize,
      changeRankingVisable,
      fontColorRender,
      weatherFactorColorRender,
      windDirection,
      remFontSize,
    };
  },
});

